// Core
import React from "react"
import styled from "styled-components"

// Style
import size from "../../styles/size"

const P = styled.p`
  font-size: 2.2rem;
  font-weight: 400;
  line-height: 31px;
  text-align: ${({ center }) => (center ? "center" : "initial")};
  color: ${({ darkBG }) => (darkBG ? "#ffffff" : "#555555")};

  width: ${({ narrow }) => (narrow ? "60%" : "100%")};
  margin: ${({ narrow }) => (narrow ? "auto" : "initial")};

  @media (max-width: ${size.laptop}) {
    width: 100%;
    margin: initial;
  }
`

export default function Paragraph(props) {
  return <P {...props}>{props.children}</P>
}
